var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12V14H12.6667V12H11.3334V10.6667H15.3334V12H14ZM3.33335 12V14H2.00002V12H0.666687V10.6667H4.66669V12H3.33335ZM7.33335 4V2H8.66669V4H10V5.33333H6.00002V4H7.33335ZM7.33335 6.66667H8.66669V14H7.33335V6.66667ZM2.00002 9.33333V2H3.33335V9.33333H2.00002ZM12.6667 9.33333V2H14V9.33333H12.6667Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-icon.519a1a7e.svg";
export { ForwardRef as ReactComponent };